// One reusable solution for external links in the native app / PWA shell.
// Raw <a href> anchors to other origins bypass utils/navigation.js and either
// strand the user inside the WebView or silently fail. This global handler
// intercepts those clicks and routes them through openExternalUrl, which uses
// the Capacitor Browser on native and a proper new tab on web.

import { Capacitor } from '@capacitor/core';
import { openExternalUrl } from './navigation';

const isNativeApp = Capacitor.isNativePlatform();
const isPWA =
  window.matchMedia?.('(display-mode: standalone)')?.matches ||
  window.navigator.standalone === true;

export const initExternalLinkHandler = () => {
  if (!isNativeApp && !isPWA) return;
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('sms:')) return;
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return;
    }
    if (url.origin === window.location.origin) return;
    e.preventDefault();
    openExternalUrl(url.href);
  });
};
